import LayoutDashBoard from '../../../components/layoutDashBoard/LayoutDashBoard'
import { Step3Component } from '../../../components/modal/personalDataModal/PersonalDataSteeps'
import { Input } from '../../../components/ui/Input'
import { useChangePassword } from './hook/useChangePassword';

const ChangePassword = () => {

    const {
        currentPassword,
        errors,
        handleChange,
        onChangePassword
    } = useChangePassword();

    return (
        <LayoutDashBoard activeMenu={'Alterar senha'}>
            <div>
                <Input
                    type={'password'}
                    label={'Senha Atual'}
                    value={currentPassword}
                    onChange={handleChange}
                    name={'currentPassword'}
                />
                {errors['currentPassword'] && <span className="w-full text-start text-red-500 text-sm">{errors['currentPassword']}</span>}
            </div>
            <Step3Component onSubmitPassword={(p1, p2) => onChangePassword(p1, p2)} />
        </LayoutDashBoard>
    )
}

export default ChangePassword